import type { SVGProps } from "react"

import type { IconType } from "@productlane/ui"
import { NucleoFillIcon } from "@productlane/ui"

const iconComponents = new Map<string, IconType>()
/** A tab's icon as the component menu items take, one per icon so it never remounts. */
export function tabIconComponent(icon: string): IconType {
	const cached = iconComponents.get(icon)
	if (cached) return cached
	const Icon = ({ className }: SVGProps<SVGSVGElement>) => (
		<NucleoFillIcon icon={icon} className={className} />
	)
	iconComponents.set(icon, Icon)
	return Icon
}
